import * as React from "react";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
// import {Field} from "../form/Field";
// import {Select} from "../form/fields/Select";
// import {api} from "../../api";
import {IWindow} from "../../index";
// import {BarChart} from "../charts/BarChart";
// import {DoughnutChat} from "../charts/DoughnutChat";

const IWindow: IWindow = (window as IWindow);

export class SupportFormData {
    @observable election_id = null;
    @observable position_id = null;
    @observable party_id = IWindow.initialState.user.party_id;
}

export class SupportForm extends CrudForm {
    modelName = 'Support';
    showSubmitButton = false;
    @observable party_candidates: [];
    @observable candidate_by_position: any = [];
    @observable other_party_candidates: any = [];
	@observable is_admin = IWindow.initialState.user.user_type;
     
    @observable check_lists: any = [];

    

    onLoadCheckLists = () => {
	
    };

    onChangeElection = () => {
    };

    getCandidateRow = (candidate: any) => {
    };

    onChangePosition = (position: any) => {
    };

    onLoadElections = () => {
    };

    renderFields() {
        return (

            <>
			 
			
                <div className="row">
                    <div className="ml-auto col-md-3" >
                        
						
						 
                    </div>
					 
                </div>

                <div className="row">

                    <div className="col-xl-12 d-flex flex-column"
                         >
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-header d-flex align-items-center">
                                <span className="icon-structure mr-2"></span>
                                <h6>For Query and Concern</h6> 
                            </div>
                            <div className="card-body py-0 d-flex flex-column">
                                <div className="row no-gutters flex-grow-1">
                                    <div
                                        className="col-sm-2 dash-sep-sm-left py-4 d-sm-flex flex-sm-column ">
                                        <div className="">
                                            <div className="stat-label">Q&A: </div>
                                        </div>
                                       
										
                                    </div>
									
									
									<div
                                        className="col-sm-6 dash-sep-sm-left py-4 d-sm-flex flex-sm-column ">
                                        <div className="">
                                            <div className="stat"><a target="_blank" href="http://electionsmonitor.com.ng/faq">http://electionsmonitor.com.ng/faq</a></div>
                                        </div>
                                    </div>
                                </div>
								
								
								<div className="row no-gutters flex-grow-1">
                                    <div
                                        className="col-sm-2 dash-sep-sm-left py-4 d-sm-flex flex-sm-column ">
                                        <div className="">
                                            <div className="stat-label">Phone (Whatsapp):</div>
                                        </div>
                                       
										
                                    </div>
									
									
									<div
                                        className="col-sm-6 dash-sep-sm-left py-4 d-sm-flex flex-sm-column ">
                                        <div className="">
                                            <div className="stat">+2349098871502</div>
                                        </div>
                                    </div>
                                </div>
								
								
								
								<div className="row no-gutters flex-grow-1">
                                    <div
                                        className="col-sm-2 dash-sep-sm-left py-4 d-sm-flex flex-sm-column ">
                                        <div className="">
                                            <div className="stat-label">Email:</div>
                                        </div>
                                       
										
                                    </div>
									
									
									<div
                                        className="col-sm-6 dash-sep-sm-left py-4 d-sm-flex flex-sm-column ">
                                        <div className="">
                                            <div className="stat"><a href="mailto:info@hephzibah.com.ng">info@hephzibah.com.ng</a></div>
                                        </div>
                                    </div>
                                </div>
								
								
								<div className="row no-gutters flex-grow-1">
                                    <div
                                        className="col-sm-2 dash-sep-sm-left py-4 d-sm-flex flex-sm-column ">
                                        <div className="">
                                            <div className="stat-label">Email:</div>
                                        </div>
                                       
										
                                    </div>
									
									
									<div
                                        className="col-sm-6 dash-sep-sm-left py-4 d-sm-flex flex-sm-column ">
                                        <div className="">
                                            <div className="stat"><a href="mailto:info@electionsmonitor.com.ng">info@electionsmonitor.com.ng</a></div>
                                        </div>
                                    </div>
                                </div>
								
								
								
								<div className="row no-gutters flex-grow-1">
                                    <div
                                        className="col-sm-2 dash-sep-sm-left py-4 d-sm-flex flex-sm-column ">
                                        <div className="">
                                            <div className="stat-label">Web:</div>
                                        </div>
                                       
										
                                    </div>
									
									
									<div
                                        className="col-sm-6 dash-sep-sm-left py-4 d-sm-flex flex-sm-column ">
                                        <div className="">
                                            <div className="stat"><a  target="_blank" href="https://www.electionsmonitor.com.ng">www.electionsmonitor.com.ng</a></div>
                                        </div>
                                    </div>
                                </div>
								
								
								
								
								
								
								
                            </div>
                        </div>
                    </div>

                    

                </div>

                  

            </>
        );
    }
}

export class SupportPage extends React.Component {
    modelName = 'Support';

    render() {
        return (
            <>
                <SupportForm
                />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/SupportPage.tsx